import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  GpWebPayPaymentSetupParameters,
  PaymentOption,
  PaymentProviderType,
  PaymentProviderTypes,
  PaymentSetup,
} from '../../../../core/model';
import { Occ } from '../../../../core/occ';
import { ConverterService } from '../../../../core/util';
import { PAYMENT_OPTION_NORMALIZER, PAYMENT_SETUP_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class CheckoutPaymentConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  loadPaymentOptions(userId: string, cartId: string): Observable<PaymentOption[]> {
    const url = this.occEndpointsService.buildUrl('paymentOptions', {
      urlParams: { userId },
      queryParams: { cartCode: cartId },
    });
    return this.httpClient.get<Occ.PaymentOptions>(url).pipe(
      map((response) => response.paymentOptions),
      this.converterService.pipeableMany(PAYMENT_OPTION_NORMALIZER)
    );
  }

  setPaymentOption(userId: string, cartId: string, paymentOption: PaymentOption): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    return this.httpClient.patch(
      this.occEndpointsService.buildUrl('setPaymentOption', {
        urlParams: {
          userId,
          cartCodeOrType: cartId,
        },
        queryParams: { paymentType: paymentOption.type },
      }),
      null,
      { headers }
    );
  }

  getPaymentSetup(userId: string, orderCode: string, paymentProvider: PaymentProviderType): Observable<PaymentSetup> {
    return this.httpClient
      .get<Occ.PaymentRequest>(
        this.occEndpointsService.buildUrl('getPaymentSetup', {
          urlParams: {
            userId,
            orderCode,
          },
          queryParams: {
            paymentProvider,
          },
        })
      )
      .pipe(
        map((response) => ({ ...response, paymentProviderType: paymentProvider })),
        this.converterService.pipeable(PAYMENT_SETUP_NORMALIZER)
      );
  }

  proceedNetsPayment(userId: string, orderCode: string, paymentId: string): Observable<any> {
    return this.httpClient.post(
      this.occEndpointsService.buildUrl('proceedPayment', {
        urlParams: {
          userId,
          orderCode,
          paymentProvider: PaymentProviderTypes.NETS,
        },
        queryParams: {
          paymentId,
        },
      }),
      null
    );
  }

  proceedGpWebPayPayment(userId: string, orderCode: string, params: GpWebPayPaymentSetupParameters): Observable<any> {
    return this.httpClient.post(
      this.occEndpointsService.buildUrl('proceedPayment', {
        urlParams: {
          userId,
          orderCode,
          paymentProvider: PaymentProviderTypes.GPWEBPAY,
        },
        queryParams: {
          ...params,
        },
      }),
      null
    );
  }
}
